import { Popover as ReactTinyPopover, ArrowContainer } from 'react-tiny-popover'

export const Popover = ({ children, ...props }) => <ReactTinyPopover {...props}>{children}</ReactTinyPopover>
export const PopoverArrowContainer = ({ children, ...props }) => <ArrowContainer {...props}>{children}</ArrowContainer>
